module.exports = __webpack_public_path__ + "static/media/logo-uniao-seguradora.620e5907.png";